import { ExternalLink, FileText as FileTextIcon } from 'lucide-react';
import { useResolvedMediaUrl } from '../../../hooks/useResolvedMediaUrl';

const isImageRef = (v: string): boolean => /\.(jpe?g|png|gif|webp)(\?|$)/i.test(v || '');

/**
 * Thumbnail for an attached document. `documentFile` may be an S3 key or a full
 * URL — it's resolved to a signed URL for display when it's a key.
 */
export function DocThumb({ documentFile, documentName }: { documentFile: string; documentName: string }) {
  const url = useResolvedMediaUrl(documentFile);
  if (isImageRef(documentFile) && url) {
    return <img src={url} alt={documentName} className="w-full h-full object-cover" />;
  }
  return (
    <div className="w-16 h-16 rounded-xl bg-indigo-100 flex items-center justify-center">
      <FileTextIcon className="w-8 h-8 text-indigo-600" />
    </div>
  );
}

/** "Preview" link that opens the resolved (signed) URL in a new tab. */
export function DocPreviewLink({ documentFile }: { documentFile: string }) {
  const url = useResolvedMediaUrl(documentFile);
  return (
    <a
      href={url || '#'}
      onClick={(e) => {
        if (!url) e.preventDefault();
      }}
      target="_blank"
      rel="noopener noreferrer"
      aria-disabled={!url}
      className={`inline-flex items-center gap-1.5 text-xs font-medium ${
        url ? 'text-indigo-600 hover:text-indigo-700' : 'text-gray-400 cursor-wait'
      }`}
    >
      <ExternalLink className="w-3.5 h-3.5" />
      Preview
    </a>
  );
}
